import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import React from "react";
import { IoPricetagOutline } from "react-icons/io5";
dayjs.extend(relativeTime);

const TicketInformation = ({ ticket }) => {
  if (!ticket?.ticketCategory?.ticketCategoryName) return null;

  return (
    <span className='ticket-details-meta-item'>
      <IoPricetagOutline /> {ticket.ticketCategory.ticketCategoryName}
    </span>
  );
};

export default TicketInformation;
